/**
 * Created with IntelliJ IDEA.
 * User: tendlich
 *
 * Controller is responsible to display the extended list view in the ticketcontainer
 */

define(function (require) {
    "use strict";
    var LE = require("app");
    var Loader = require("ui/loader/Loader");
    var TicketExtendedContainerLayout = require("connection-views/layouts/ticketTab/TicketExtendedContainerLayout");
    var TicketTabController = {};
    var CP_CONST = require("connection-const");

    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        TicketTabController = Marionette.Controller.extend({

            initialize: function (options) {
                this.connectionPanelContextModel = options.connectionPanelContextModel;
                this.channel = LEConnection.media.channel(LE.mediaCodes.connection.channels.CONTENT_CONTAINER);
                this.ticketTabChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.TICKET_TAB);
                this._createArticleLayout();
                this._setEventListeners();
            },
            _setEventListeners: function () {
                this.listenTo(this.connectionPanelContextModel, "change:topElement",this._onTopElementChange);
                this.listenTo(this.channel.vent,"TicketExtendedContainerController::container:close", this._setArticleClosed);
                this.listenTo(this.articleContainerLayout, "TicketExtendedContainerController::container:close", this._setArticleClosed);
                this.listenTo(this.articleContainerLayout, "TicketExtendedContainerController::container:clickInside", this._onCLickInside);
                this.listenTo(this.channel.vent, "TicketExtendedContainerController::container:displayTicketView", this._displayTicketView);
                this.listenTo(this.channel.vent, "TicketExtendedContainerController::container:displayExtendedView", this._displayExtendedView);
                this.listenTo(LEConnection.vent, 'ticket:error', this._onError);
                this.listenTo(LEConnection.vent, 'layout:domain:ready', this._setArticleLayout);
            },

            _setArticleClosed: function () {
                //closes the extended panel
                this.connectionPanelContextModel.setSelectedTicket(null);
                if(this.fromExtendedView){
                    this.ticketTabChannel.vent.trigger("show:extendedList");
                    this.fromExtendedView = false;
                }else{
                    this.connectionPanelContextModel.setTicketListIsOpen(false);
                    this.connectionPanelContextModel.setTicketViewIsOpen(false);
                    this.articleContainerLayout.close();
                }
            },

            _onCLickInside: function(){
                this.connectionPanelContextModel.setTopElement(CP_CONST.PAGE.TICKET);
            },

            _onError: function () {
                this._cleanup();
            },
            _setArticleLayout: function () {
                LEConnection.vent.trigger("ConnectionPanelLayoutController:showRegion:Ticket", {
                    view: this.articleContainerLayout
                });
            },

            _createArticleLayout: function () {
                this.articleContainerLayout = new TicketExtendedContainerLayout({
                    model: this.connectionPanelContextModel
                });
            },

            _onTopElementChange: function () {
                this.articleContainerLayout.setOnTop(this.connectionPanelContextModel.getTopElement()===CP_CONST.PAGE.ARTICLE);
            },

            _displayView: function (view) {
                if (view) {
                    //this.articleContainerLayout.fadeInFadeOut();
                    this.articleContainerLayout.show();
                    this.articleContainerLayout.pageBodyRegion.show(view);
                } else {
                    this._onError();
                }
            },

            _displayTicketView: function (_options) {
                var options = _options ||{};
                this.fromExtendedView = options.fromExtendedView;
                this._displayView(options.view);
                this.connectionPanelContextModel.setTicketViewIsOpen(true);
                _.defer(_.bind(function(){
                    this.articleContainerLayout.changeToDetailedView();
                },this));
            },

            _displayExtendedView: function (view) {
                this.connectionPanelContextModel.setTicketViewIsOpen(false);
                this.connectionPanelContextModel.setTicketListIsOpen(true);
                this._displayView(view);
                _.defer(_.bind(function(){
                    this.articleContainerLayout.changeToExtendedView();
                },this));
            },

            _cleanup: function () {
                this._hideNoData();
                this._closeLoader();
            },

            _hideNoData: function () {
                this.articleContainerLayout.toggleNoData(true);
            },

            //------------------------------------------------------------
            // Loader Logic
            //------------------------------------------------------------

            _closeLoader: function () {
                if (this.loader) {
                    this.loader.close();
                }
            },
            _showLoader: function () {
                this.loader = new Loader({
                    permutation: Loader.PERMUTATION.G,
                    el: this.articleContainerLayout.ui.pageBody
                });
                this.loader.render();
            }
        });

    });
    return TicketTabController;
});


